/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as RepoStrongRef from '../../../com/atproto/repo/strongRef.defs'

const $nsid = 'app.witchsky.theme.collectionitem'

type $nsid = typeof $nsid

export { $nsid }

/** Record representing a theme's inclusion in a specific theme collection. Consumers should ignore duplicate items. */
type Main = {
  $type: 'app.witchsky.theme.collectionitem'

  /**
   * Reference to the theme included in the collection.
   */
  subject: RepoStrongRef.Main

  /**
   * Reference to the app.witchsky.theme.collection record.
   */
  collection: l.AtUriString
  createdAt: l.DatetimeString
}

export type { Main }

/** Record representing a theme's inclusion in a specific theme collection. Consumers should ignore duplicate items. */
const main = /*#__PURE__*/ l.record<'tid', Main>(
  'tid',
  $nsid,
  /*#__PURE__*/ l.object({
    subject: /*#__PURE__*/ l.ref<RepoStrongRef.Main>(
      (() => RepoStrongRef.main) as any,
    ),
    collection: /*#__PURE__*/ l.string({ format: 'at-uri' }),
    createdAt: /*#__PURE__*/ l.string({ format: 'datetime' }),
  }),
)

export { main }

const $type = $nsid

type $type = typeof $type

export { $type }

export const $isTypeOf = /*#__PURE__*/ main.isTypeOf.bind(main)
export const $build = /*#__PURE__*/ main.build.bind(main)
export const $assert = /*#__PURE__*/ main.assert.bind(main)
export const $check = /*#__PURE__*/ main.check.bind(main)
export const $cast = /*#__PURE__*/ main.cast.bind(main)
export const $ifMatches = /*#__PURE__*/ main.ifMatches.bind(main)
export const $matches = /*#__PURE__*/ main.matches.bind(main)
export const $parse = /*#__PURE__*/ main.parse.bind(main)
export const $safeParse = /*#__PURE__*/ main.safeParse.bind(main)
export const $validate = /*#__PURE__*/ main.validate.bind(main)
export const $safeValidate = /*#__PURE__*/ main.safeValidate.bind(main)
